<app-sp-page-error (pageButtonClick)="onButtonClick()" buttonText="Back to home" title="Oops" subtitle="Something went wrong" [imageType]="ImageType.OUT_OF_ORDER">
  <p>Something went wrong when processing your request.<br>
    Please try again in a few minutes. If the error persists,
    <a href="https://soprism.com/#contact" matTooltip="Contact us." matTooltipHideDelay="10">contact us</a> for support.
  </p>
</app-sp-page-error>
